export const FETCH_SME_DASHBOARD_REQUEST = 'FETCH_SME_DASHBOARD_REQUEST';
export const FETCH_SME_DASHBOARD_SUCCESS = 'FETCH_SME_DASHBOARD_SUCCESS';
export const FETCH_SME_DASHBOARD_FAILURE = 'FETCH_SME_DASHBOARD_FAILURE';
export const FETCH_SME_ANALYTICS_REQUEST = 'FETCH_SME_ANALYTICS_REQUEST';
export const FETCH_SME_ANALYTICS_SUCCESS = 'FETCH_SME_ANALYTICS_SUCCESS';
export const FETCH_SME_ANALYTICS_FAILURE = 'FETCH_SME_ANALYTICS_FAILURE';